















import Vue from 'vue'
import { ref, computed } from '@vue/composition-api'
export default Vue.extend({
  props: ['memoryCookieStatusCounts'],
  setup(props) {

    const loading = computed(() => props.memoryCookieStatusCounts === undefined)

    function getColorForStatus(status: string) {
      if (status === 'IMMEDIATE') return 'success-bg'
      if (status === 'NO_MEMORY_COOKIE') return 'danger-bg'
      if (status === 'CONDITIONAL_ON_CMP') return 'warning-bg'
      if (status === 'CONDITIONAL_ON_CMP_AND_REFRESH') return 'warning-bg'
      return 'default-bg'
    }

    return {
      loading,
      getColorForStatus,
    };
  }
})
